import { TableOfContentsItem } from "@/components/blog/TableOfContents";

export const aiOverviewsSeoTableOfContents: TableOfContentsItem[] = [
  {
    id: "que-son-ai-overviews",
    title: "¿Qué son los AI Overviews de Google?",
    subItems: [
      { id: "como-funcionan", title: "Cómo funcionan en 2026" },
      { id: "datos-clave", title: "Datos clave: cobertura y alcance" }
    ]
  },
  {
    id: "impacto-trafico",
    title: "Impacto en el tráfico orgánico",
    subItems: [
      { id: "ganadores-citados", title: "Ganadores: fuentes citadas" },
      { id: "perdedores-no-citados", title: "Perdedores: posiciones 3-10 no citadas" }
    ]
  },
  {
    id: "impacto-por-sector",
    title: "Impacto por sector e industria",
    subItems: [
      { id: "salud-tecnologia", title: "Salud y tecnología: los más afectados" },
      { id: "ecommerce-local", title: "eCommerce y negocios locales" }
    ]
  },
  {
    id: "estrategias-adaptacion",
    title: "Estrategias de adaptación al nuevo SEO",
    subItems: [
      { id: "autoridad-tematica", title: "Construir autoridad temática" },
      { id: "contenido-estructurado", title: "Contenido estructurado para citación" },
      { id: "schema-markup", title: "Schema markup y datos estructurados" }
    ]
  },
  {
    id: "geo-optimizacion",
    title: "GEO: Optimización para motores generativos",
    subItems: [
      { id: "que-es-geo", title: "Qué es el GEO y por qué importa" },
      { id: "geo-vs-seo", title: "GEO vs SEO tradicional" }
    ]
  },
  {
    id: "predicciones-futuro",
    title: "Predicciones para 2026-2027",
    subItems: [
      { id: "expansion-cobertura", title: "Expansión a consultas transaccionales" },
      { id: "personalizacion-ia", title: "Personalización y búsqueda multimodal" }
    ]
  }
];
